export enum AttachmentErrorCode {
  FILE_SIZE_EXCEEDED = 'FILE_SIZE_EXCEEDED',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  QUERY_NOT_FOUND = 'QUERY_NOT_FOUND',
  SAVE_ATTACHMENT_ERROR = 'SAVE_ATTACHMENT_ERROR',
  INVALID_MIME_TYPE = 'INVALID_MIME_TYPE',
  PARSE_ERROR = 'PARSE_ERROR',
  MALWARE_DETECTED = 'MALWARE_DETECTED'
}
